import { RequestProps, StudentRequestProps } from "./types";

export const transformRequests = (requests: any[]): RequestProps[] => {
  return requests.map((request) => transformRequest(request));
};

const transformRequest = (request: any): RequestProps => {
  const id = request.id;
  const date = formatToYYYYMMDD(request.created);
  const students = getStudents(request.request_info.request_details.classes);
  const slug = request.slug;

  return { id, date, students, slug };
};

const formatToYYYYMMDD = (date: string) => {
  const dateObj = new Date(date);
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");

  return `${year}/${month}/${day}`;
};

const getStudents = (classes: []) => {
  const mappedClasses: StudentRequestProps[] = [];
  classes.forEach((_class: any) =>
    mappedClasses.push({
      subjects: _class.subjects,
      class: _class.class,
      id: _class.id,
      expectation: _class.expectation,
    })
  );

  return mappedClasses;
};

export const samplePromise = (data = {}, timer = 300): Promise<any> => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(data);
    }, 300);
  });
};

const mapClasses = (classes: string[]) => {
  const yearClasses = classes.filter((_class) =>
    _class.toLowerCase().includes("year")
  );
  const usualClasses: string[] = [];

  let mappedClasses: { [key: string]: string } = {};

  yearClasses.map((_class, index) => {
    if (index <= 5) {
      usualClasses.push(`Primary ${index + 1}`);
    } else if (index > 5 && index <= 8) {
      usualClasses.push(`JSS ${index - 6 + 1}`);
    } else {
      usualClasses.push(`SSS ${index - 9 + 1}`);
    }
    mappedClasses = {
      ...mappedClasses,
      [usualClasses[index].toLowerCase()]: _class,
    };
  });

  return mappedClasses;
};

export const compareClassname = (classes: string[], _class: string) => {
  const mappedClasses = mapClasses(classes);

  return mappedClasses[_class.toLowerCase()];
};
